import { getFnameLname } from '~/utils/utils';
import { ISalesOrderResponse } from '~/interfaces/get-sales-order';
function normalizeSingleLineAddress(address: string | null): string {
  return (
    address
      ?.replace(/\r?\n|\r/g, ' ')
      .replace(/\s+/g, ' ')
      .trim() || ''
  );
}

export const normalizeCheckoutCart = (checkoutCart: ISalesOrderResponse) => {
  const {
    ProductList = [],
    TotalTax = 0,
    balanceAmount = 0,
    Email = '',
    Name = '',
    Street = '',
    StreetNumber = '',
    City = '',
    State = '',
    ZipCode = '',
    Phone = '',
  } = checkoutCart;

  const { firstName, lastName } = getFnameLname(Name);

  return {
    shipping: {
      firstName,
      lastName,
      addressLine: normalizeSingleLineAddress(Street),
      addressLine2: normalizeSingleLineAddress(StreetNumber),
      addressCity: City,
      addressState: State,
      addressZip: ZipCode,
      phone: Phone,
    },
    items: ProductList,
    tax: TotalTax,
    total: balanceAmount,
    email: Email,
  };
};
export const affirmPlanId = '7071';
